import styled, { css } from 'styled-components';
import { Typography } from '@mui/material';
import type { PlanApprovalStatus } from '../../../types';
import { Flex, FlexColumn } from '../../Flex';
import { fontSize, fontWeight, radius, space } from '../../../style/utils';

type StatusProps = { $status?: PlanApprovalStatus };

const statusBorder = css<StatusProps>`
  ${({ $status, theme }) =>
    $status === 'confirmed' &&
    css`
      border-color: ${theme.palette.status.success.main};
    `}

  ${({ $status, theme }) =>
    $status === 'rejected' &&
    css`
      border-color: ${theme.palette.status.error.soft};
    `}
`;

const statusBackground = css<StatusProps>`
  ${({ $status, theme }) =>
    $status === 'confirmed' &&
    css`
      background: ${theme.palette.status.success.bg};
    `}

  ${({ $status, theme }) =>
    $status === 'rejected' &&
    css`
      background: ${theme.palette.status.error.bg};
    `}
`;

const headerLayout = css<StatusProps>`
  align-items: center;
  gap: ${space('sm')};
  padding: ${space('mdMinus', 'mdPlus')};
  background: ${({ theme }) => theme.palette.surface.tinted};
  ${statusBackground}
`;

export const ApprovalCard = styled(FlexColumn)<StatusProps>`
  max-width: 100%;
  border: 1px solid ${({ theme }) => theme.palette.border.emphasis};
  border-radius: ${radius('lg')};
  overflow: hidden;
  ${statusBorder}
`;

export const ApprovalCardHeader = styled(Flex)<StatusProps>`
  ${headerLayout}
`;

export const ApprovalCardHeaderButton = styled.button.attrs({
  type: 'button',
})<StatusProps>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: none;
  cursor: pointer;
  font: inherit;
  text-align: left;
  ${headerLayout}
`;

export const ApprovalCardTitle = styled(Typography).attrs({
  component: 'span',
})<StatusProps>`
  font-size: ${fontSize('md')};
  font-weight: ${fontWeight('semibold')};

  ${({ $status, theme }) =>
    $status === 'confirmed' &&
    css`
      color: ${theme.palette.status.success.main};
    `}

  ${({ $status, theme }) =>
    $status === 'rejected' &&
    css`
      color: ${theme.palette.status.error.soft};
    `}
`;

export const ApprovalCardBody = styled(FlexColumn)`
  padding: ${space('md', 'mdPlus')};
  gap: ${space('lg')};
`;
